<!-- 通用form表单子组件 -->
<template>
  <div class="base-form-item">
    <!-- 输入框 -->
    <el-input
      v-if="formItem.type === 'input'"
      v-model="formData[formItem.prop]"
      :class="`w-${formItem.width}` || 'w-220'"
      :placeholder="formItem.placeholder || '请输入内容'"
      :maxlength="formItem.maxlength || 50"
      :max="formItem.max"
      :minlength="formItem.minlength"
      :min="formItem.min"
      :disabled="formItem.disabled"
      :readonly="formItem.readonly"
      @blur="blurValue(formItem.prop)"
      autocomplete="off"
      auto-complete="new-password"
      :type="formItem.input_type || 'text'"
    >
      <template slot="append" v-if="formItem.unit">{{
          formItem.unit
        }}
      </template>
    </el-input>
    <!-- <div class="flex-between" v-if="formItem.type === 'inputBTN'">
      <el-select
        :value="formData[formItem.prop]"
        :multiple="formItem.multiple || false"
        :clearable="formItem.clearable || true"
        :filterable="formItem.filterable || true"
        :allow-create="formItem.allow_create || false"
        :placeholder="formItem.placeholder || '请输入内容'"
        :disabled="formItem.disabled"
        :collapse-tags="formItem.collapseTags"
        :remote="formItem.remote || false"
        :remote-method="formItem.remote_method"
        @change="changeValue($event, formItem.prop)"
      >
        <el-option
          v-for="(item, index) in formItem.options"
          :name="
            (formItem.valueKey
              ? item[formItem.valueKey] +
                (formItem.labelKey ? item[formItem.labelKey] : item.label)
              : item.value) || index
          "
          :key="
            (formItem.valueKey
              ? item[formItem.valueKey] +
                (formItem.labelKey ? item[formItem.labelKey] : item.label)
              : index) || index
          "
          :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
          :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
        ></el-option>
      </el-select>
      
      <div class="w-100" style="margin-left: 15px;">
        <el-button
          class="w-100"
          @click="handleActions(formItem, formData)"
          type="primary"
        >
          检索
        </el-button
        >
      </div>
    </div> -->
    <!-- 手机输入框 -->
    <div class="flex-between">
      <el-input
        v-if="formItem.type === 'mobile'"
        v-model="formData[formItem.prop]"
        :class="`w-${formItem.width}` || 'w-220'"
        :placeholder="formItem.placeholder || '请输入内容'"
        :maxlength="formItem.maxlength || 50"
        :max="formItem.maxlength || 50"
        :minlength="formItem.minlength"
        :min="formItem.minlength"
        :disabled="formItem.disabled"
        :readonly="formItem.readonly"
        @blur="blurValue(formItem.prop)"
        autocomplete="off"
        auto-complete="new-password"
      >
      </el-input>
      <div class="w-100" v-if="formItem.code || false">
        <el-button
          :disabled="btnDisabled"
          class="w-100"
          @click="sendCaptcha(formData[formItem.prop])"
          type="primary"
        >
          {{ btnCodeText }}
        </el-button
        >
      </div>
    </div>
    <!-- 密码 -->
    <el-input
      v-if="formItem.type === 'password'"
      type="password"
      v-model="formData[formItem.prop]"
      :class="`w-${formItem.width}` || 'w-220'"
      :placeholder="formItem.placeholder || '请输入内容'"
      :maxlength="formItem.maxlength"
      :minlength="formItem.minlength"
      :disabled="formItem.disabled"
      :readonly="formItem.readonly"
      :show-password="formItem.show_password || true"
      @blur="blurValue(formItem.prop)"
      autocomplete="off"
      auto-complete="new-password"
    >
    </el-input>
    <!-- 数字输入 -->
    <template v-if="formItem.type === 'inputNumber'">
      <div class="flex">
        <el-input-number
          @blur="blurValue(formItem.prop)"
          v-model="formData[formItem.prop]"
          :placeholder="formItem.placeholder || '请输入内容'"
          :disabled="formItem.disabled"
          :min="formItem.min || -9999999"
          :max="formItem.max || 9999999"
          :controls="formItem.controls || false"
          :precision="formItem.precision || 0"
        >
        </el-input-number>
        <span v-if="formItem.unit" class="m-l-14">{{ formItem.unit }}</span>
      </div>
    </template>
    <!-- 文本框 -->
    <el-input
      v-else-if="formItem.type === 'textarea'"
      type="textarea"
      :maxlength="formItem.maxlength"
      :rows="formItem.rows || 4"
      v-model="formData[formItem.prop]"
      :placeholder="formItem.placeholder || '请输入内容'"
      :disabled="formItem.disabled"
    ></el-input>
    <!-- 下拉 -->
    <el-select
      v-else-if="formItem.type === 'selectToOther'"
      :value="formData[formItem.prop]"
      :multiple="formItem.multiple || false"
      :clearable="formItem.clearable || true"
      :filterable="formItem.filterable || true"
      :allow-create="formItem.allow_create || false"
      :placeholder="formItem.placeholder || '请输入内容'"
      :disabled="formItem.disabled"
      :collapse-tags="formItem.collapseTags"
      :remote="formItem.remote || false"
      :remote-method="formItem.remote_method"
      @change="changeValue($event, formItem.prop,formItem.options)"
    >
      <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
      <el-option
        v-for="(item, index) in formItem.options"
        :name="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : item.value) || index
        "
        :key="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : index) || index
        "
        :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
        :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
      ></el-option>
    </el-select>
    <el-select
      v-else-if="formItem.type === 'select'"
      :value="formData[formItem.prop]"
      :multiple="formItem.multiple || false"
      :clearable="formItem.clearable === undefined ? true : formItem.clearable"
      :filterable="formItem.filterable || true"
      :allow-create="formItem.allow_create || false"
      :placeholder="formItem.placeholder || '请输入内容'"
      :disabled="formItem.disabled"
      :collapse-tags="formItem.collapseTags"
      :remote="formItem.remote || false"
      :remote-method="formItem.remote_method"
      @change="changeValue($event, formItem.prop)"
    >
      <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
      <el-option
        v-for="(item, index) in formItem.options"
        :name="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : item.value) || index
        "
        :key="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : index) || index
        "
        :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
        :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
      ></el-option>
    </el-select>
    <!--    两个下拉 -->
    <div class="df fdr select-two" v-else-if="formItem.type === 'select_two'">
      <el-select
        :value="formData[formItem.prop]"
        :multiple="formItem.multiple || false"
        :clearable="formItem.clearable || false"
        :filterable="formItem.filterable || false"
        :allow-create="formItem.allow_create || false"
        :placeholder="formItem.placeholder || '请输入内容'"
        :disabled="formItem.disabled"
        :collapse-tags="formItem.collapseTags"
        :remote="formItem.remote || false"
        :remote-method="formItem.remote_method"
        @change="changeValue($event, formItem.prop)"
      >
        <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
        <el-option
          v-for="(item, index) in formItem.options"
          :name="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : item.value) || index
        "
          :key="
          (formItem.valueKey
            ? item[formItem.valueKey] +
              (formItem.labelKey ? item[formItem.labelKey] : item.label)
            : index) || index
        "
          :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
          :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
        ></el-option>
      </el-select>
      <el-select
        :value="formData[formItem.prop2]"
        :multiple="formItem.multiple2 || false"
        :clearable="formItem.clearable2 || true"
        :filterable="formItem.filterable2 || true"
        :allow-create="formItem.allow_create2 || false"
        :placeholder="formItem.placeholder2 || '请输入内容'"
        :disabled="formItem.disabled2"
        :collapse-tags="formItem.collapseTags2"
        :remote="formItem.remote2 || false"
        :remote-method="formItem.remote_method2"
        @change="changeValue($event, formItem.prop2)"
      >
        <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
        <el-option
          v-for="(item, index) in formItem.options2"
          :name="
          (formItem.valueKey2
            ? item[formItem.valueKey2] +
              (formItem.labelKey2 ? item[formItem.labelKey2] : item.label)
            : item.value) || index
        "
          :key="
          (formItem.valueKey2
            ? item[formItem.valueKey2] +
              (formItem.labelKey2 ? item[formItem.labelKey2] : item.label)
            : index) || index
        "
          :label="formItem.labelKey2 ? item[formItem.labelKey2] : item.name"
          :value="formItem.valueKey2 ? item[formItem.valueKey2] : item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="df fdr" v-else-if="formItem.type === 'select_two_CD'">
      <div class="select-two-left">
        <el-select
          :value="formData[formItem.prop]"
          :multiple="formItem.multiple || false"
          :clearable="formItem.clearable || false"
          :filterable="formItem.filterable || false"
          :allow-create="formItem.allow_create || false"
          :placeholder="formItem.placeholder || '请输入内容'"
          :disabled="formItem.disabled"
          :collapse-tags="formItem.collapseTags"
          :remote="formItem.remote || false"
          :remote-method="formItem.remote_method"
          @change="changeValue($event, formItem.prop)"
        >
          <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
          <el-option
            v-for="(item, index) in formItem.options"
            :name="
            (formItem.valueKey
              ? item[formItem.valueKey] +
                (formItem.labelKey ? item[formItem.labelKey] : item.label)
              : item.value) || index
          "
            :key="
            (formItem.valueKey
              ? item[formItem.valueKey] +
                (formItem.labelKey ? item[formItem.labelKey] : item.label)
              : index) || index
          "
            :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
            :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="select-two-right">
        <el-select
          :value="formData[formItem.prop2]"
          :multiple="formItem.multiple2 || false"
          :clearable="formItem.clearable2 || true"
          :filterable="formItem.filterable2 || true"
          :allow-create="formItem.allow_create2 || false"
          :placeholder="formItem.placeholder2 || '请输入内容'"
          :disabled="formItem.disabled2"
          :collapse-tags="formItem.collapseTags2"
          :remote="formItem.remote2 || false"
          :remote-method="formItem.remote_method2"
          @change="changeValue($event, formItem.prop2)"
        >
          <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
          <el-option
            v-for="(item, index) in formItem.options2"
            :name="
            (formItem.valueKey2
              ? item[formItem.valueKey2] +
                (formItem.labelKey2 ? item[formItem.labelKey2] : item.label)
              : item.value) || index
          "
            :key="
            (formItem.valueKey2
              ? item[formItem.valueKey2] +
                (formItem.labelKey2 ? item[formItem.labelKey2] : item.label)
              : index) || index
          "
            :label="formItem.labelKey2 ? item[formItem.labelKey2] : item.name"
            :value="formItem.valueKey2 ? item[formItem.valueKey2] : item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 下拉单位 -->
    <el-select
      v-else-if="formItem.type === 'select_unit'"
      :value="formData[formItem.prop]"
      :multiple="formItem.multiple || false"
      :clearable="formItem.clearable || true"
      :filterable="formItem.filterable || true"
      :allow-create="formItem.allow_create || false"
      :placeholder="formItem.placeholder || '请输入内容'"
      :disabled="formItem.disabled"
      :collapse-tags="formItem.collapseTags"
      :remote="formItem.remote || false"
      :remote-method="formItem.remote_method"
      @change="changeValue($event, formItem.prop)"
    >
      <!--// 循环元素key的值可能重复，目前用value + label给key赋值  -->
      <el-option
        v-for="item in unit_list"
        :name="item.name"
        :key="item.value"
        :label="formItem.labelKey ? item[formItem.labelKey] : item.name"
        :value="formItem.valueKey ? item[formItem.valueKey] : item.value"
      ></el-option>
    </el-select>
    <!-- 级联下拉 -->
    <el-cascader
      v-else-if="formItem.type === 'cascader'"
      :value="formData[formItem.prop]"
      :options="formItem.options"
      :clearable="formItem.clearable || true"
      :filterable="formItem.filterable || true"
      :multiple="formItem.multiple || false"
      :props="formItem.propsData || { expandTrigger: 'hover' }"
      :placeholder="formItem.placeholder || '请输入内容'"
      :disabled="formItem.disabled"
      :collapse-tags="formItem.collapseTags"
      :class="
        formData[formItem.prop] && formData[formItem.prop].length
          ? 'select'
          : ''
      "
      @change="changeValue($event, formItem.prop)"
    ></el-cascader>
    <!-- 日期选择器 -->
    <el-date-picker
      v-else-if="formItem.type === 'date'"
      v-model="formData[formItem.prop]"
      :disabled="formItem.disabled"
      type="date"
      :value-format="formItem.format || 'yyyy-MM-dd'"
      :placeholder="formItem.placeholder || '请输入内容'"
    >
    </el-date-picker>
    <el-date-picker
      v-else-if="formItem.type === 'datetime'"
      v-model="formData[formItem.prop]"
      :disabled="formItem.disabled"
      :readonly="formItem.readonly"
      type="datetime"
      :value-format="formItem.format || 'yyyy-MM-dd'"
      :placeholder="formItem.placeholder || '请输入内容'"
      format="yyyy-MM-dd HH:mm:ss"
    >
    </el-date-picker>
    <!-- 年份选择器 -->
    <el-date-picker
      v-else-if="formItem.type === 'year'"
      v-model="formData[formItem.prop]"
      :disabled="formItem.disabled"
      type="year"
      :value-format="formItem.format || 'yyyy'"
      :placeholder="formItem.placeholder || '请输入内容'"
    >
    </el-date-picker>
    <!-- 区间日期选择器 -->
    <template v-if="formItem.type === 'datePicker'">
      <el-date-picker
        v-model="formData[formItem.prop]"
        type="daterange"
        :value-format="formItem.format || 'yyyy-MM-dd HH:mm:ss'"
        range-separator="-"
        start-placeholder="请输入开始日期"
        end-placeholder="请输入结束日期"
        :default-time="['00:00:00', '23:59:59']"
      ></el-date-picker>
    </template>
    <!-- 区间日期选择器 -->
    <template v-if="formItem.type === 'datetimerange'">
      <el-date-picker
        v-model="formData[formItem.prop]"
        type="datetimerange"
        range-separator="至"
        start-placeholder="请输入开始日期"
        end-placeholder="请输入结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
      ></el-date-picker>
    </template>
    <!-- 单选 -->
    <el-radio-group
      v-else-if="formItem.type === 'radio'"
      @change="changeValue($event, formItem.prop)"
      v-model="formData[formItem.prop]"
      :disabled="formItem.disabled"
    >
      <el-radio
        v-for="formItem in formItem.options"
        :key="formItem.value"
        :label="formItem.value"
      >
        {{ formItem.name }}
      </el-radio>
    </el-radio-group>
    <!-- switch单选 -->
    <template v-else-if="formItem.type === 'switch'">
      <vxe-switch
        v-model="formData[formItem.prop]"
        :open-label="formItem.label1 || '启用'"
        :open-value="formItem.value1 || true"
        :close-label="formItem.label2 || '禁用'"
        :close-value="formItem.value2 || false"
      >
      </vxe-switch>
    </template>
    <template v-if="formItem.type === 'checkbox_item'">
      <div>
        <el-checkbox @change="changeValue($event, formItem.prop)" v-model="formData[formItem.prop]" :disabled="formItem.disabled?formItem.disabled:false">{{
            formItem.check_label
          }}
        </el-checkbox>
      </div>
    </template>
    <template v-if="formItem.type === 'checkbox'">
      <div>
        <el-checkbox-group v-model="formData[formItem.prop]">
          <el-checkbox
            :label="option.value"
            v-for="option in formItem.options"
            :key="option.value"
          >
            {{ option.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </template>
    <template v-if="formItem.type === 'desc'">
      <span class="light-color">{{ formItem.desc }}</span>
    </template>
    <template v-if="formItem.type === 'text'">
      <span>{{ formData[formItem.prop] }}</span>
    </template>
    <template v-else-if="formItem.type === 'radio_text'">
      <el-tag :type="getType(formData[formItem.prop], formItem.options)">
        {{ formData[formItem.prop] | filterlistStatus(formItem.options) }}
      </el-tag>
    </template>
  </div>
</template>
<script>
// import { deepClone } from "@/utils/deepClone";
import Template from "@/views/system-management/template/index.vue";

export default {
  props: {
    formItem: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {
      }
    },
    form: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        this.formData = val;
      },
      deep: true,
      immediate: true
    },
    "formItem.type": {
      handler(val) {
        if (val === "select_unit") {
          this.getProductUnit();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      input_english_name: "",
      input_key: "",
      restaurants: [],
      unit_list: [],
      formData: {}
    };
  },
  filters: {
    filterlistStatus(val, list) {
      if (!list) {
        return "";
      }
      let obj = list.find((v) => v.id == val);
      if (obj) return obj.name;
      else return "";
    }
  },
  methods: {
    getType(val, list) {
      if (!val || !list) {
        return "";
      }
      let obj = list.find((v) => v.id == val);
      if (obj) return obj.type;
      else return "";
    },
    changeValue(value, key, item = []) {
      let paymentCompanyCountry = '';
      let paymentName = '';
      if(item.findIndex(e =>e.id === value) > -1){
        paymentCompanyCountry = item[item.findIndex(e =>e.id === value)].paymentCompanyCountry
        paymentName = item[item.findIndex(e =>e.id === value)].paymentName
      }
      this.$emit("changeValue", { key, value,paymentCompanyCountry,paymentName });
    },
    changeValueOther(value, key,item) {
      // let paymentCompanyCountry = '';
      // if(item.findIndex(e =>e.id === value) > -1){
      //   paymentCompanyCountry = item[item.findIndex(e =>e.id === value)].paymentCompanyCountry
      // }
      // this.$emit("changeValueOther", { key, value,paymentCompanyCountry });
    },
    blurValue(key) {
      this.$emit("changeValue", { key, value: this.formData[key] });
    },
    async getProductUnit() {
      const res = await this.$api.common.get("dict/by_type/product_unit");
      this.unit_list = res;
    },
    handleActions(item, scope) {
      this.$emit(item.click, scope);
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-select,
.el-date-editor,
.el-radio-group,
.el-input-number,
.el-cascader,
.el-upload {
  width: 100% !important;
  text-align: left;
}


::v-deep .el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}

::v-deep .el-input, .el-textarea {
  min-width: 244px !important;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 120px;
  margin-left: 10px;
  vertical-align: bottom;
}

::v-deep .el-autocomplete-suggestion {
  li {
    line-height: 16px !important;
  }
}

::v-deep {
  .el-cascader {
    &.select {
      input::placeholder {
        color: #606266;
      }
    }
  }
}

.rate-box {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}

.select-two {
  ::v-deep {
    .el-select, .el-input {
      width: 100px !important;
      min-width: 122px !important;
    }
  }
}
.select-two-left{
  ::v-deep {
    .el-select, .el-input {
      width: 90px !important;
      min-width: 112px !important;
    }
  }
}
.select-two-right{
  ::v-deep {
    .el-select, .el-input {
      width: 200px !important;
      min-width: 222px !important;
    }
  }
}
</style>
